import type { IconSvgObject } from './types';

const Male02Icon: IconSvgObject = [
  ["path", { d: "M14.5002 16.5L19.1328 18.044C19.9495 18.3163 20.5004 19.0805 20.5004 19.9414V21.5H3.50037V19.9414C3.50037 19.0805 4.05124 18.3162 4.86793 18.044L9.5002 16.5V14.5622C7.71936 13.1684 6.5002 11.4999 6.5002 7.91667C6.5002 4.32682 8.45494 2.49986 11.4925 2.49986C13.6434 2.49986 14.5387 3.49986 14.5387 3.49986C17.0771 3.49986 17.5002 5.59705 17.5002 7.91667C17.5002 11.4999 16.281 13.1684 14.5002 14.5622V16.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Male02Icon;
